import { gql } from '@apollo/client';

const RECOMMENDED_PRODUCTS = gql`
  query fetchRecommendedProducts($input: RecommendProductsInput) {
    recommendProducts(input: $input) {
      extras
      hospital
    }
  }
`;

export default RECOMMENDED_PRODUCTS;
